const uri = 'https://www.eyeticket.co.uk/api';
//const uri = 'https://www.parmelee-safety.com/api-dev';

// Development flag for automatic token setting
const DEV_AUTO_AUTH = false;
let devAuthToken = null;

export async function forgotPassword(email) {
    const url = `${uri}/Authenticate/ForgotPassword`;
    const headers = new Headers({
        'x-api-key': process.env.REACT_APP_API_KEY,
        'Content-Type': 'application/json'
    });

    const payload = {
        email: email
    };

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        });

        if (!response.ok) {
            throw new Error(`Failed to reset password: ${response.status} ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        throw new Error(error.message);
    }
}

export async function logout() {
  const url = "/Authenticate/Logout";
  try {
    deleteCookie(false);
    const response = await buildRequest(url, "POST");
    const text = await response.text();

    try {
      const data = JSON.parse(text);

      if (!response.ok) {
        if (response.status === 401) {
          deleteCookie(false);
        } else {
          /*
          throw new Error(
            `Failed to logout: ${response.status} ${response.statusText}` +
            (data.detail ? ` | ${data.detail}` : "")
          );*/
        }
      }

      await new Promise((resolve) => setTimeout(resolve, 1000));
      window.location.href = '/login';
      return data;
    } catch (parseErr) {
      if (!response.ok) {
        if (response.status === 401) {
          deleteCookie(false);
        } else {
          /*
          throw new Error(
            `Failed to logout: ${response.status} ${response.statusText}` +
            (text ? ` | ${text}` : "")
          );*/
        }
      }

      await new Promise((resolve) => setTimeout(resolve, 1000));
      window.location.href = '/login';
      return;
    }
  } catch (err) {
    window.location.href = '/login';
    throw new Error(err.message);
  }
}


export async function login(email, password) {
  const url = `${uri}/Authenticate/Login`;
  const headers = new Headers({
    'x-api-key': process.env.REACT_APP_API_KEY,
    'Content-Type': 'application/json'
  });

  const payload = {
    email: email,
    password: password
  };

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      if (response.status === 401) {
        const responseData = await response.json();
        const message = typeof responseData === 'string'
          ? responseData
          : responseData?.message || 'Invalid Username or Password';
        throw new Error(message);
      } else {
        throw new Error('Invalid Username or Password');
      }
    }

    const res = await response.json();
    
    if (DEV_AUTO_AUTH && res.token) {
      devAuthToken = res.token;
    }
    
    return res;
  } catch (error) {
    throw new Error(error.message || 'Invalid Username or Password');
  }
}


export async function register(payload) {
    const url = `${uri}/authenticate/register`;
    const headers = new Headers({
        'x-api-key': process.env.REACT_APP_API_KEY,
        'Content-Type': 'application/json'
    });

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        });

        if (!response.ok) {
            throw new Error(`Failed to register: ${response.status} ${response.statusText}`);
        }

        return response.json();
    } catch (error) {
        throw new Error(error.message);
    }
}

export const getCookie = (name, isBearer = true) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      let token = parts.pop().split(';').shift().trim();
      token = `${isBearer ? 'Bearer ' : ''}${token}`;
      return token;
    }
    return null;
  };
  
export const deleteCookie = (withReload = true) => {
    document.cookie = `token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    document.cookie = `username=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;

    if(withReload){
    document.location = '/';
  }
    //logout();
};


export const buildRequest = async (endpoint, method = "GET", body = null, authorisation = null) => {
    const url = `${uri}${endpoint}`;
    
    const authToUse = authorisation || (DEV_AUTO_AUTH && devAuthToken ? devAuthToken : null);
    
    const options = {
        method,
        credentials: "include",
        headers: {
            // DEV TESTING: uncomment authorization, change domain, manually set token
            //...(authToUse && { 'Authorization': 'Bearer ' + authToUse }),
            "Content-Type": "application/json"
        }
    };

    if (body) {
        options.body = JSON.stringify(body);
    }

    return fetch(url, options);
};

export async function authenticateSelfRaise(email, surname) {
  const url = `${uri}/SelfRaiseEyeTicket/Verify`;
  const headers = new Headers({
    'Content-Type': 'application/json'
  });

  const payload = {
    email: email,
    surname: surname
  };

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      if (response.status === 401) {
        const responseData = await response.json();
        const message = typeof responseData === 'string'
          ? responseData
          : responseData?.message || 'Invalid Email and Surname combination';
        throw new Error(message);
      } else {
        throw new Error('Invalid Email and Surname combination');
      }
    }
    const res = await response.json();
    
    if (DEV_AUTO_AUTH && res.token) {
      devAuthToken = res.token;
    }
    
    return res;
  } catch (error) {
    throw new Error(error.message || 'Invalid Email and Surname combination');
  }
}